import { getCoach, SearchCoachByName } from "../services/CoachService";
import {
  coachesFetchSuccess,
  coachLoading,
  coachError,
  setCoachDetails,
  setCoachProfile,
} from "../store/slices/coachSlice";

export const getCoaches = (apiInstance, q) => async (dispatch) => {
  dispatch(coachLoading(true));
  try {
    const response = await SearchCoachByName(apiInstance, q);
    dispatch(coachesFetchSuccess(response));
  } catch (err) {
    dispatch(coachError(err.message || "An error occurred"));
  } finally {
    dispatch(coachLoading(false));
  }
};

export const selectedCoachAction =
  (apiInstance, coachUserId) => async (dispatch) => {
    try {
      const coachDetails = await getCoach(apiInstance, coachUserId);
      dispatch(setCoachDetails(coachDetails));
    } catch (err) {
      throw new Error(`Failed to  ${err.message}`);
    }
  };

export const fetchCoachDetails =
  (apiInstance, coachUserId) => async (dispatch) => {
    try {
      dispatch(coachLoading(true));
      dispatch(coachError(null));

      const coachDetails = await getCoach(apiInstance, coachUserId);
      dispatch(setCoachProfile(coachDetails));
      dispatch(coachLoading(false));
    } catch (err) {
      dispatch(coachLoading(false));
      dispatch(coachError(err.message || "Failed to fetch coach details"));
    }
  };
